import { Col, Form } from "react-bootstrap";
import FormDeviceValueControl from "components/form-control/FormDeviceValueControl";
import { useActuatorConfigurationContext } from "context/ActuatorConfigurationContext";
import { useEffect } from "react";
import styled from "@emotion/styled";

const LabelCol = styled(Col)`
    width: 187px;
`;

const InputCol = styled(Col)`
    min-width: 500px;
`;

export const RawAnalogConfig = ({
    isIOControllerState,
    value,
    activate_value,
    deactivate_value,
    onChange,
}: {
    isIOControllerState: any;
    value?: number;
    activate_value?: number;
    deactivate_value?: number;
    onChange: (field: string, updatedValue: string) => void;
}) => {
    const renderAnalogConfig = () => {
        if (isIOControllerState.isGenericAnalogOutput) {
            return (
                <>
                    <Form.Row className="mt-2">
                        <LabelCol className="flex-grow-0 flex-basis-auto">
                            <Form.Label>Activation Voltage</Form.Label>
                        </LabelCol>
                        <InputCol className="mb-2">
                            <Form.Group className="mb-0">
                                <FormDeviceValueControl
                                    value={activate_value}
                                    type="text"
                                    {...{
                                        format: isIOControllerState.format,
                                        accuracy: isIOControllerState.accuracy,
                                        min: isIOControllerState.minmax[0],
                                        max: isIOControllerState.minmax[1],
                                    }}
                                    aria-label="activate-value"
                                    onChange={(e) =>
                                        onChange?.(
                                            "activate_value",
                                            e.target.value
                                        )
                                    }
                                />
                                <div className="analog-config-unit">
                                    {isIOControllerState.unit}
                                </div>
                            </Form.Group>
                            <Col
                                className="mt-2 text-primary-blue-4"
                                lg={12}
                            >{`Minimum is ${isIOControllerState.minmax[0]}${isIOControllerState.unit} and maximum is ${isIOControllerState.minmax[1]}${isIOControllerState.unit}.`}</Col>
                        </InputCol>
                    </Form.Row>{" "}
                    <Form.Row className="mt-2">
                        <LabelCol className="flex-grow-0 flex-basis-auto">
                            <Form.Label>Deactivation Voltage</Form.Label>
                        </LabelCol>
                        <InputCol className="mb-2">
                            <Form.Group className="mb-0">
                                <FormDeviceValueControl
                                    value={deactivate_value}
                                    type="text"
                                    {...{
                                        format: isIOControllerState.format,
                                        accuracy: isIOControllerState.accuracy,
                                        min: isIOControllerState.minmax[0],
                                        max: isIOControllerState.minmax[1],
                                    }}
                                    aria-label="deactivate-value"
                                    onChange={(e) =>
                                        onChange?.(
                                            "deactivate_value",
                                            e.target.value
                                        )
                                    }
                                />
                                <div className="analog-config-unit">
                                    {isIOControllerState.unit}
                                </div>
                            </Form.Group>
                            <Col
                                className="mt-2 text-primary-blue-4"
                                lg={12}
                            >{`Minimum is ${isIOControllerState.minmax[0]}${isIOControllerState.unit} and maximum is ${isIOControllerState.minmax[1]}${isIOControllerState.unit}.`}</Col>
                        </InputCol>
                    </Form.Row>
                </>
            );
        } else {
            return (
                <Form.Row>
                    <Col>
                        <Form.Label>Value</Form.Label>
                    </Col>
                    <Col lg={10} xs={12} className="mb-2">
                        <Form.Group className="mb-0">
                            <FormDeviceValueControl
                                value={value}
                                type="text"
                                {...{
                                    format: isIOControllerState.format,
                                    accuracy: isIOControllerState.accuracy,
                                    min: isIOControllerState.minmax[0],
                                    max: isIOControllerState.minmax[1],
                                }}
                                aria-label="value"
                                onChange={(e) => {
                                    // Dimmer not supported now
                                }}
                            />
                            <div className="analog-config-unit">
                                {isIOControllerState.unit}
                            </div>
                        </Form.Group>
                        <Col
                            className="mt-2 text-primary-blue-4"
                            lg={12}
                        >{`Minimum is ${isIOControllerState.minmax[0]}${isIOControllerState.unit} and maximum is ${isIOControllerState.minmax[1]}${isIOControllerState.unit}.`}</Col>
                    </Col>
                </Form.Row>
            );
        }
    };

    return <>{renderAnalogConfig()}</>;
};

const AnalogConfig = () => {
    const {
        editedActuator,
        editedActuator: { mode, activate_value, deactivate_value },
        setEditedActuator,
        actuator: { value },
        isIOControllerState,
    } = useActuatorConfigurationContext();

    useEffect(() => {
        setEditedActuator({
            ...editedActuator,
            activate_value: activate_value,
            deactivate_value: deactivate_value,
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mode, setEditedActuator, activate_value, deactivate_value]);

    return (
        <RawAnalogConfig
            isIOControllerState={isIOControllerState}
            value={value}
            activate_value={activate_value}
            deactivate_value={deactivate_value}
            onChange={(field, updatedValue) =>
                setEditedActuator({
                    ...editedActuator,
                    [field]: updatedValue,
                })
            }
        />
    );
};

export default AnalogConfig;
